var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('busstop-select',{attrs:{"isEnableAttribute":"enableDropOff","setDefaultBusstop":_vm.setDefaultBusstop},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }